var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2469 32.4455H12.7385C5.57812 32.4455 2.51562 29.383 2.51562 22.2226V22.033C2.51562 15.558 5.06771 12.4371 10.7844 11.8975C11.3677 11.8538 11.9219 12.2913 11.9802 12.8892C12.0385 13.4871 11.601 14.0267 10.9885 14.085C6.40937 14.508 4.70312 16.6663 4.70312 22.0476V22.2372C4.70312 28.1726 6.80312 30.2726 12.7385 30.2726H22.2469C28.1823 30.2726 30.2823 28.1726 30.2823 22.2372V22.0476C30.2823 16.6372 28.5469 14.4788 23.8802 14.085C23.2823 14.0267 22.8302 13.5017 22.8886 12.9038C22.9469 12.3059 23.4573 11.8538 24.0698 11.9121C29.874 12.408 32.4698 15.5434 32.4698 22.0622V22.2518C32.4698 29.383 29.4073 32.4455 22.2469 32.4455Z",
    fill: "#8F8F8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 22.9708C16.9021 22.9708 16.4062 22.475 16.4062 21.8771V5.28125C16.4062 4.68333 16.9021 4.1875 17.5 4.1875C18.0979 4.1875 18.5938 4.68333 18.5938 5.28125V21.8771C18.5938 22.475 18.0979 22.9708 17.5 22.9708Z",
    fill: "#8F8F8F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3922 9.62786C22.1151 9.62786 21.838 9.52578 21.6193 9.30703L17.5068 5.19453L13.3943 9.30703C12.9714 9.72995 12.2714 9.72995 11.8484 9.30703C11.4255 8.88411 11.4255 8.18411 11.8484 7.7612L16.7339 2.87578C17.1568 2.45286 17.8568 2.45286 18.2797 2.87578L23.1651 7.7612C23.588 8.18411 23.588 8.88411 23.1651 9.30703C22.961 9.52578 22.6693 9.62786 22.3922 9.62786Z",
    fill: "#8F8F8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/uploadFile.696949273aaa86d4c55039fc247e3166.svg";
export { ForwardRef as ReactComponent };